import { render, staticRenderFns } from "./aliCaptcha.vue?vue&type=template&id=5ed725b5"
import script from "./aliCaptcha.vue?vue&type=script&lang=js"
export * from "./aliCaptcha.vue?vue&type=script&lang=js"
import style0 from "./aliCaptcha.vue?vue&type=style&index=0&id=5ed725b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports